const getStyles = () => {
    return {
        column: {
        },

        row: {
        },

        square: {
        },
    };
};

export default getStyles;
